import React from 'react';
import { Select, MenuItem, InputLabel, FormControl, Box } from '@mui/material';
import PropTypes from 'prop-types';

import classes from './muiSelect.module.scss';
import { Loader } from '../Loader/Loader';

export const MUISelect = (props) => {
  const {
    label,
    value,
    options,
    onChange,
    sx = {},
    minWidth = 120,
    maxWidth,
    size = 'small',
    disabled = false,
    required = false,
    isLoading = false,
  } = props;

  return (
    <Box sx={{ minWidth, maxWidth, ...sx }}>
      <FormControl className={classes.FormControl} fullWidth>
        <InputLabel required={required} size={size} id={`select-${label}`}>
          {label}
        </InputLabel>
        <Select
          size={size}
          onChange={onChange}
          value={value}
          labelId={`select-${label}`}
          label={label}
          style={{ textAlign: 'left' }}
          onClose={() => {
            setTimeout(() => {
              document.activeElement.blur();
            }, 0);
          }}
          required={required}
          disabled={disabled}
        >
          {options?.map((option) => (
            <MenuItem key={option.title} value={option.value}>
              {option?.logo && (
                <img
                  src={option?.logo}
                  id={option?.logo}
                  onError={() => (document.getElementById(option.logo).style.overflow = 'hidden')}
                  alt={`${option.title}_image`}
                  className={classes.Logo}
                />
              )}
              {option.title}
            </MenuItem>
          ))}
        </Select>
        {isLoading ? (
          <div className={classes.FormControlLoader}>
            <Loader size="small" color="#209cee" />
          </div>
        ) : null}
      </FormControl>
    </Box>
  );
};

MUISelect.propTypes = {
  label: PropTypes.string,
  value: PropTypes.any,
  options: PropTypes.array,
  onChange: PropTypes.func,
  sx: PropTypes.object,
  minWidth: PropTypes.number,
  maxWidth: PropTypes.number,
  size: PropTypes.oneOf(['small', 'medium']),
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  isLoading: PropTypes.bool,
};
